import Vue from "vue";
import VueRouter from "vue-router";
import Products from "./vue/products.vue";

const appProducts = "#app-products";
if (document.querySelectorAll(appProducts).length) {

    const router = new VueRouter({
        mode: "history"
    });
    Vue.use(VueRouter);

    var productsPageId = document.querySelector(appProducts).dataset.productspage;
    var products = new Vue({
        el: appProducts,
        data: {
            productsPageId: productsPageId
        },
        render: h => h(Products),
        router
    });
}